export default __webpack_public_path__ + "static/media/currency-circle-icon.b1d48919.svg";